import { render, staticRenderFns } from "./LearningActivity.vue?vue&type=template&id=cf45be18&"
import script from "./LearningActivity.vue?vue&type=script&lang=js&"
export * from "./LearningActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports